import React from "react"
import { IssueContext } from "../../context"
import Issue from "../../models/issue"
import { Form as FormType } from "../../models/new/forms.types"

type TProps = {
  children: React.ReactNode
}

const IssueProvider = (props: TProps) => {
  const [issues, setIssues] = React.useState<undefined | Issue[]>(undefined)
  const [archivedIssues, setArchivedIssues] = React.useState<undefined | Issue[]>(undefined)
  const [issueForms, setIssueForms] = React.useState<undefined | FormType[]>(undefined)

  return (
    <React.Fragment>
      <IssueContext.Provider
        value={{
          issues,
          setIssues,
          archivedIssues,
          setArchivedIssues,
          issueForms,
          setIssueForms,
        }}
      >
        {props.children}
      </IssueContext.Provider>
    </React.Fragment>
  )
}

export default IssueProvider
